import http from "../../http-common";

class service {

  url = "/lingua/linguaau";

  imposta(data) {
    return http.put(this.url + '/imposta', data);
  }
}

export default new service();